const S3 = {
  bucketName: "bairuha-bucket",
  dirName: "elearning",
  region: "ap-south-1",
  accessKeyId: "AKIAYCY7LW3IVD3BX3WJ",
  secretAccessKey: "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",
};
export default S3;
